export default {
    path: '/personal-data',
    name: 'Personal-Data',
    meta: {
        title: 'Обработка персональных данных',
        forVisitors: true
    },
    component: () => import('@/views/info_pages/personal_data'),
}